import { render, staticRenderFns } from "./configuration-valuable-concepts-modal.vue?vue&type=template&id=6cd5136c&scoped=true&"
import script from "./configuration-valuable-concepts-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-valuable-concepts-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-valuable-concepts-modal.scss?vue&type=style&index=0&id=6cd5136c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5136c",
  null
  
)

export default component.exports